<template>
  <div class="">
    <CoverLayout>
      <div class="addPhone" slot="content">
        <i class="icon_close" @click="handleClose"></i>
        <div class="title">
          {{ phoneNumber !== "" ? "认证" : "添加" }}手机号
        </div>
        <div class="subTitle">
          您可以通过实名认证添加多个手机号码，认证添加的手机号均可用于账号登录，
          为顺利完成实名认证，请您准确填写您的手机号！
        </div>
        <div class="steps">
          <div class="step">
            <div class="circle">1</div>
            输入实名信息
          </div>
          <div class="line"></div>
          <div class="step">
            <div class="circle">2</div>
            确认信息并支付
          </div>
        </div>
        <div class="form" v-if="active === 1">
          <div class="form-item">
            <label for="">真实姓名：</label>
            <el-input
              type="text"
              v-model="form.name"
              placeholder="输入您的姓名"
            />
          </div>
          <div class="form-item">
            <label for="">手机号：</label>
            <el-input
              type="text"
              v-model="form.phoneNumber"
              placeholder="输入您的手机号"
            />
          </div>
          <div class="form-item">
            <label for="">身份证号：</label>
            <el-input
              type="text"
              v-model="form.idCard"
              placeholder="输入您的身份证号"
            />
          </div>
        </div>
        <div class="step2" v-if="active === 2">
          <div class="infoBox">
            <div class="infoList">
              <div>真实姓名：{{ form.name }}</div>
              <div>手机号：{{ form.phoneNumber }}</div>
              <div>身份证号：{{ form.idCard }}</div>
            </div>
            <Btn
              btnText="修改"
              @handleClick="active = 1"
              :fontWeight="600"
              className="primary_plain"
              :width="47"
              :height="24"
              :radius="12"
            />
          </div>
          <div class="payLayout">
            <div class="payTip">
              确认信息无误，请使用<span>微信</span>扫码支付
            </div>
            <div class="payTip">
              扫码支付完成后，请点击下方按钮，进入下一步。
            </div>
            <div class="payMain">
              <QRcode
                v-if="qrcode.code_url"
                :QRlink="qrcode.code_url"
                :qrwidth="140"
                :qrheight="140"
              />
              <div class="payInfo">
                <div>支付金额：</div>
                <div class="money">
                  ￥<span>{{ payInfo.realNameAuthentication / 100 }}</span>
                </div>
                <div class="timerLimit">
                  二维码有效时长：<count-down ref="countdown" />
                </div>
                <div class="refresh">
                  如无法支付或者二维码已过期请点击
                  <span @click="handleRefresh">刷新</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btns">
          <Btn
            :btnText="active === 1 ? '提交并进入下一步' : '已支付，进入下一步'"
            @handleClick="active === 1 ? getPayQrcode() : handleSubmit()"
            :width="active === 1 ? 156 : 198"
          />
        </div>
        <div class="tip" v-if="active === 1">
          <i class="icon_warning"></i>
          提示：因手机号码可通过过户、注销等情况变更用户信息，为确保手机号实名认证信息匹配，三个月内未登录的手机号码再次登陆时需重新完成实名认证。
        </div>
      </div>
    </CoverLayout>
  </div>
</template>

<script>
import Btn from "./Btn.vue";
import CoverLayout from "./CoverLayout.vue";
import QRcode from "./QRcode.vue";
import { realNameAuth, realNameAuthenticationResultCheck } from "@/api/user";
import { pay, payInfo } from "@/api/pay";
import CountDown from "./CountDown.vue";
import { webSocketMixin } from '@/utils/mixins.js'
export default {
  mixins: [webSocketMixin],
  components: { CoverLayout, Btn, QRcode, CountDown },
  props: {
    phoneNumber: {
      type: String
    }
  },
  data() {
    return {
      active: 1,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      form: {
        authType: "PHONE_ADD",
        idCard: JSON.parse(sessionStorage.getItem("userInfo")).idCard,
        name: JSON.parse(sessionStorage.getItem("userInfo")).name,
        phoneNumber: ""
      },
      dialogAddPhone: false,
      payInfo: {},
      qrcode: {
        code_url: "http://www.baidu.com",
        orderId: ""
      }
    };
  },
  // created() {},
  mounted() {
    this._initSocket()
    this._socket.onmessage = (e) => {
      let { data } = e
      if (data) {
        data = JSON.parse(data)
        console.log(data)
        const { type, paySuccess, message } = data
        if (type === 2 && paySuccess) {
          // this.handleResult()
          // this.addPhoneClose()
          this.active === 1 ? this.getPayQrcode() : this.handleSubmit()
        }
      }
    }
    
    this.getPayInfo();
    console.log(this.phoneNumber);
    if (this.phoneNumber !== ""&&this.phoneNumber!==undefined) {
      this.form.phoneNumber = this.phoneNumber;
      this.form.authType = "PHONE_REFRESH";
    }
  },
  methods: {
    getPayInfo() {
      payInfo().then(res => {
        this.payInfo = res.data.d;
      });
    },
    getPayQrcode() {
      realNameAuth({
        ...this.form,
        webSocketUserId: this._socketId
      }).then(res => {
        if (res.data.c === 200) {
          this.qrcode = res.data.d;
          this.active = 2;
          this.getPayInfo();
        }
      });
    },
    handleSubmit() {
      realNameAuthenticationResultCheck(this.qrcode.orderId).then(res => {
        if (res.data.c === 200) {
          this.$message.success("认证成功!");
          this.handleClose();
        } else {
          this.$message.error(res.data.m);
        }
      });
    },
    handleClose() {
      this.$emit("addPhoneClose");
    },
    handleRefresh() {
      this.$refs.countdown.handleReset();
      this.getPayQrcode();
    }
  }
};
</script>

<style scoped lang="scss">
.addPhone {
  background: #fff;
  width: 731px;
  padding: 30px 60px 40px 60px;
  box-sizing: border-box;
  border-radius: 16px;
  position: relative;
  .icon_close {
    display: inline-block;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_fileRemove.png");
    background-size: cover;
    width: 14px;
    height: 14px;
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #6e6e6e;
    text-align: center;
    margin-bottom: 10px;
  }
  .subTitle {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #a3a3a3;
    line-height: 24px;
    text-align: center;
  }
  .steps {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    .line {
      width: 112px;
      height: 3px;
      background: #ededed;
      margin-top: 30px;
      margin-bottom: 30px;
      margin-left: 21px;
      margin-right: 21px;
    }
    .step {
      display: flex;
      cursor: pointer;
      align-items: center;
      flex-direction: row;
      .circle {
        background: #3a61b1;
        width: 39px;
        height: 39px;
        border-radius: 39px;
        color: #fff;
        font-size: 22.36px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
      }
    }
  }
  .form {
    // padding-bottom: 17px;
    text-align: center;
    // margin: 0 auto;
    .form-item {
      margin-bottom: 20px;
      label {
        width: 70px;
        display: inline-block;
        font-size: 14px;
        text-align: left;
        color: #6e6e6e;
      }
      >>> .el-input {
        width: 299px;
        height: 37px;
        .el-input__inner {
          width: 299px;
          height: 37px;
          border: 1px solid #d7d7d7;
        }

        // border: 1px solid #d7d7d7;
      }
    }
  }
  .step2 {
    .infoBox {
      width: 100%;
      height: 128px;
      background: #f0f2f5;
      border-radius: 2px;
      padding: 0px 30px 0px 20px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      .infoList {
        line-height: 32px;
        color: #6e6e6e;
      }
    }
    .payLayout {
      // box-shadow: 0px 0px 11px 0px #e6e6e6;
      // padding: 60px 0 76px 49px;
      // margin-top: 57px;
      // margin-top: 35px;
      margin-top: 20px;
      font-size: 14px;
      .payTip {
        font-size: 14px;
        color: #393939;
        // margin-bottom: 16px;
        margin-top: 0;
        span {
          color: #ff5129;
        }
      }
      .payMain {
        display: flex;
        width: 112%;
        margin-top: 20px;
        .payInfo {
          margin-left: 32px;
          display: flex;
          flex-direction: column;
          padding-bottom: 6px;
          justify-content: space-between;
          .money {
            color: #ff5129;
            font-size: 20px;
            // margin-bottom: 20px;
            span {
              font-size: 48px;
              font-weight: bold;
            }
          }
          .timerLimit {
            margin-bottom: 18px;
            span {
              color: #ff5129;
            }
          }
          .refresh {
            font-size: 14px;
            span {
              color: #47a2ff;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .btns {
    text-align: center;
    margin-top: 20px;
    // margin-bottom: 20px;
  }
  .tip {
    margin-top: 20px;
    background: #fff4f0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ff8d65;
    line-height: 24px;
    padding: 16px 23px 21px 50px;
    position: relative;
    .icon_warning {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png");
      background-size: cover;
      width: 16px;
      height: 16px;
      display: inline-block;
      position: absolute;
      left: 20px;
      top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/addPhone.vue